import { MapTo } from '@adobe/aem-react-editable-components';
import GlossaryTerm, { GlossaryTermEditConfig } from './GlossaryTerm';

export default MapTo('cob-corp-acquisition/components/creditonebank/glossary-term')(GlossaryTerm, GlossaryTermEditConfig);